import { patch } from '@/utils/api';
import { alertErrorMessage } from '@/utils/alerts';

const useClient = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const colorToNumber = (color: string): number => {
    const colorMap: { [key: string]: number } = {
      gray: 1,
      green: 2,
      yellow: 3,
      red: 4,
    };

    return colorMap[color.toLowerCase()];
  };
  const numberToColor = (number: number): string => {
    const colorMap: { [key: number]: string } = {
      1: 'gray',
      2: 'green',
      3: 'yellow',
      4: 'red',
    };
    return colorMap[number] || 'gray';
  };

  const upsertClientColorStatus = async (
    id: number,
    color: string,
    churnRisk: string
    // eslint-disable-next-line consistent-return
  ) => {
    try {
      return await patch<string>('clients/updateColorStatus', {
        id,
        color,
        churnRisk,
      });
    } catch (err) {
      alertErrorMessage(
        `There was an error saving the risk status. Try again or contact the system administrator.`
      );
    }
  };
  return {
    upsertClientColorStatus,
    numberToColor,
    colorToNumber,
  };
};
export default useClient;
